<template>
  <div>
    <div>
      <load-profile />

      <b-card
        id="container"
        ref="container"
      >
        <b-card-text class="mb-2">
          <h5>
            {{ $t('topic_summary_desc') }}
          </h5>
        </b-card-text>
        <div
          class="d-flex flex-row mb-4 mr-4"
        >
          <div
            class="d-flex flex-row flex-item border rounded px-2 py-2 justify-content-between"
            :class="enableSummaryTopic ? 'border-primary' : ''"
            style="min-width: 600px;"
          >
            <div class="d-flex flex-column">
              <h4>
                {{ $t('enable_topic_summary') }}
              </h4>
              <div style="margin-top: 4px;">
                {{ $t('pages.chatAssignment.type') }}
              </div>

              <div class="d-flex gap-3 mt-1 mb-1">
                <b-form-radio
                  v-model="isAutoPushToRag"
                  :disabled="!enableSummaryTopic"
                  :value="false"
                  name="price-type"
                  class="mr-3"
                >
                  {{ $t('pages.chatAssignment.options.manual.option') }}
                </b-form-radio>

                <b-form-radio
                  v-model="isAutoPushToRag"
                  :disabled="!enableSummaryTopic"
                  :value="true"
                  name="price-type"
                  class="mr-3"
                >
                  {{ $t('pages.chatAssignment.options.auto.option') }}
                </b-form-radio>
              </div>

              <div
                :style="{ display: 'grid', gridTemplateColumns: '18px 1fr', gap: '0.5rem', alignItems: 'start' }"
              >
                <feather-icon
                  :style="{ marginTop: '3px' }"
                  icon="InfoIcon"
                  size="16"
                />
                <span v-if="!isAutoPushToRag">
                  {{ $t('manually_summary_desc') }}
                  <b-link
                    class="text-primary cursor-pointer"
                    @click="redirectToConversationSummary"
                  >
                    {{ $t('here') }}
                  </b-link>
                </span>
                <span v-else>
                  {{ $t('enable_topic_summary_desc') }}
                </span>
              </div>

              <div
                v-if="isAutoPushToRag"
                class="p-2 rounded mt-1"
                style="background-color: #f8f9fa;"
              >
                <!-- <div
                  class="d-flex align-items-center"
                >
                  <b-form-checkbox
                    v-model="isEnablePushToRag"
                    :disabled="!enableSummaryTopic"
                    name="callback-toggle"
                    switch
                  >
                    <span class="font-weight-bold">
                      {{
                        $t(
                          `${
                            isEnablePushToRag ? 'enable' : 'disable'
                          }_push_chat_to_rag`
                        )
                      }}
                    </span>
                  </b-form-checkbox>
                </div> -->
                <div>
                  <label for="numberOfFrequentlyTopicSendToRag">{{
                    $t('number_of_frequently_topic_send_to_raq')
                  }}</label>
                  <b-form-input
                    id="numberOfFrequentlyTopicSendToRag"
                    v-model.number="numberOfFrequentlyTopicSendToRag"
                    name="numberOfFrequentlyTopicSendToRag"
                    type="number"
                    min="0"
                    @click.stop
                  />
                </div>
              </div>
            </div>

            <b-form-checkbox
              v-model="enableSummaryTopic"
              @click.stop
            />
          </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <b-button
            variant="primary"
            @click="updateTopicSummary"
          >
            {{ $t('button.saveChanges') }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BFormCheckbox,
  BButton,
  BFormInput,
  BFormRadio,
  BLink,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import questionRepository from '@/repositories/Api/QuestionRepository'

const MerchantRepository = Repository.get('merchant')

export default {
  components: {
    BCard,
    BCardText,
    BFormCheckbox,
    BButton,
    BFormInput,
    BFormRadio,
    BLink,
  },
  data() {
    return {
      enableSummaryTopic: false,
      enablePushToRag: false,
      numberOfFrequentlyTopicSendToRag: 2,
      isEnablePushToRag: false,
      isAutoPushToRag: false,
    }
  },
  watch: {
    enableSummaryTopic(value) {
      if (!value) {
        this.isEnablePushToRag = false
      }
    },
  },
  async mounted() {
    await this.getMerchant()
  },
  methods: {
    async getMerchant() {
      try {
        const response = await MerchantRepository.show()
        const { data } = response.data
        this.enableSummaryTopic = data.isEnableTopicSummary || false
        this.numberOfFrequentlyTopicSendToRag = data.numberOfFrequentlyTopicSendToRag
        this.isEnablePushToRag = data.isAutoPushToRag || false
        this.isAutoPushToRag = data.isAutoPushToRag || false
      } catch (err) {
        const { data } = err.response
        const { message } = data
        if (message === 'error.recordNotFound') await this.createAssignment()
      }
    },
    async updateTopicSummary() {
      try {
        const payload = {
          isEnableTopicSummary: this.enableSummaryTopic,
          isEnablePushToRag: this.isEnablePushToRag,
          numberOfFrequentlyTopicSendToRag:
              this.numberOfFrequentlyTopicSendToRag,
          isAutoPushToRag: this.isAutoPushToRag,
        }
        await questionRepository.enable(payload)
      } catch (err) {
        // alert(err)
      } finally {
        await this.getMerchant()
      }
    },
    redirectToConversationSummary() {
      const path = this.$router.resolve({
        path: 'conversation-summary',
      })
      console.log(path)
      window.open(
        path.href,
        '_blank',
      )
    },
  },
  setup() {
    const permissionType = 'summary-conversation'
    return { permissionType }
  },
}
</script>

<style lang="scss" scoped>
  .flex-item--half {
    width: 100%;
    max-width: 60%;
  }
</style>
